<div class="colab-manager-wrapper">

  <div class="col-sm-2 no-padding colab-manager-menu">
    <ul>
      <li [class.active]="currentView === 'general-view'"><a (click)="currentView = 'general-view'"><i class="fa fa-th-large" aria-hidden="true"></i>Visão Geral</a></li>
      <li [class.active]="currentView === 'group-view'"><a (click)="currentView = 'group-view'"><i class="fa fa-object-group" aria-hidden="true"></i>Grupo</a></li>
      <li [class.active]="currentView === 'economy-view'"><a (click)="currentView = 'economy-view'"><i class="fa fa-university" aria-hidden="true"></i>Economia</a></li>
      <li [class.active]="currentView === 'partners-view'"><a (click)="currentView = 'partners-view'"><i class="fa fa-address-card" aria-hidden="true"></i>Parceiros</a></li>
    </ul>
  </div>

  <div *ngIf="!loading" class="col-sm-10 no-padding" [ngSwitch]="currentView">
    <group-select *ngIf="currentView !=='partners-view'" [selected]="selectedGroups" [groups]="groups" (selectGroup)="onSelectGroup($event)"></group-select>

    <general-view [reports]="reports" [selectedGroups]="selectedGroups" [places]="placesMetrics" *ngSwitchCase="'general-view'"></general-view>
    <group-view [groups]="groups" [reports]="reports" [selectedGroups]="selectedGroups" *ngSwitchCase="'group-view'"></group-view>
    <economy-view [reports]="reports" [selectedGroups]="selectedGroups" *ngSwitchCase="'economy-view'"></economy-view>
    <partners-view [places]="placesMetrics"  *ngSwitchCase="'partners-view'"></partners-view>
  </div>


  <div class="col-sm-10 no-padding no-margin" *ngIf="loading">
    <ng-core-loading class="relative-loading"></ng-core-loading>
  </div>
</div>
